/**
 * Line chart of average €/L per month — ports `renderPriceTrend()` from
 * the legacy `static/analysis.js`.
 */

import { Line } from "react-chartjs-2";

import { ensureChartDefaults } from "./chartDefaults";
import { usePalette } from "./usePalette";
import type { PriceTrendPoint } from "../../../api/types";

export interface PriceTrendChartProps {
  points: PriceTrendPoint[];
}

export default function PriceTrendChart({ points }: PriceTrendChartProps) {
  const palette = usePalette();
  ensureChartDefaults(palette);

  const data = {
    labels: points.map((p) => p.month),
    datasets: [
      {
        label: "Avg €/L",
        data: points.map((p) => p.avg_price_per_liter),
        borderColor: palette.accent,
        backgroundColor: palette.accent + "33",
        tension: 0.25,
        fill: true,
        pointRadius: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: {
          callback: (value: string | number) => Number(value).toFixed(2),
        },
      },
    },
    plugins: { legend: { display: false } },
  } as const;

  return <Line data={data} options={options} />;
}
